import React from 'react';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import TimePeriodSwitcher from './TimePeriodSwitcher';

export interface Props {}

export const TimePeriodSwitcherSticky: React.FC<Props> = props => {
  return (
    <Sticky marginTop={100} marginLeft="preserve">
      {() => <TimePeriodSwitcher />}
    </Sticky>
  );
};
TimePeriodSwitcherSticky.displayName = 'TimePeriodSwitcherSticky';

export default TimePeriodSwitcherSticky;
